import { useContext } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'Root/App/Button'
import { Context } from 'Root/Contexts/RouterHistory'

library.add(faArrowLeft)

const Back = () => {
  const { back } = useContext(Context)

  return (
    <Button
      className="bg-gray-200 text-gray-500"
      subtype="circle"
      onClick={() => back()}
      icon={<FontAwesomeIcon icon={['fas', 'arrow-left']} />}
    />
  )
}

export default Back
